import { IonCard } from '@ionic/react';

import styles from './RecordingProcessing.module.css';

interface RecordingProcessingProps {
  title?: string;
  progress?: number;
}

export const RecordingProcessing = ({ title = 'Uploading recording', progress }: RecordingProcessingProps) => {
  return (
    <IonCard className={styles.card}>
      {progress !== undefined && (
        <div className={styles.progress}>
          <div
            className={styles.completed}
            style={
              {
                '--progress': progress,
              } as React.CSSProperties
            }
          />
        </div>
      )}
      <p className={styles.title}>{title}</p>
    </IonCard>
  );
};
